import React from 'react';

import { Icon, Label } from '@mairistem/composants';

import './MouvementPJCount.css';

interface MouvementPJCountProps {
  totalPjCount: number;
}

const MouvementPJCount = ({ totalPjCount }: MouvementPJCountProps) => (
  <Label
    color="grey"
    className="mouvement-pj-count-label"
  >
    {totalPjCount}
    <Icon name="paperclip" />
  </Label>
);

export default MouvementPJCount;
